import * as React from "react";
import { cn } from "@repo/utils/cn";
import Image from "next/image";

export interface FormContainerProps {
  icon?: {
    src: string;
    alt: string;
  };
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
}

export const FormContainer: React.FC<FormContainerProps> = ({
  icon,
  title,
  subtitle,
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        "uipm:bg-[var(--surface-surface-secondary)] uipm:rounded-[var(--radius-radius-lg)] uipm:p-[var(--container-card-padding)]",
        "uipm:flex uipm:flex-col uipm:gap-[var(--spacing-primitives-32)] uipm:w-full",
        className,
      )}
    >
      {(icon || title || subtitle) && (
        <div className="uipm:flex uipm:flex-col uipm:gap-[var(--spacing-primitives-32)]">
          {(icon || title) && (
            <div className="uipm:flex uipm:gap-[var(--spacing-primitives-16)] uipm:items-center">
              {icon && (
                <div className="uipm:w-[var(--spacing-primitives-48)] uipm:h-[var(--spacing-primitives-48)] uipm:flex-shrink-0">
                  <Image
                    src={icon.src}
                    alt={icon.alt}
                    width={48}
                    height={48}
                    className="uipm:w-full uipm:h-full uipm:object-contain"
                  />
                </div>
              )}
              {title && (
                <div className="uipm:flex-1">
                  <h5 className="uipm:heading-5 uipm:text-[var(--typography-colors-text-heading)]">
                    {title}
                  </h5>
                </div>
              )}
            </div>
          )}
          {subtitle && (
            <p className="uipm:body-medium uipm:text-[var(--typography-colors-text-faded-dark)]">
              {subtitle}
            </p>
          )}
        </div>
      )}

      <div className="uipm:flex uipm:flex-col">{children}</div>
    </div>
  );
};
